import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { PrestadorAnotacao, PrestadorAnotacaoSalvarRequest, PrestadorAnotacaoTipo } from './prestador-anotacoes.model';
import { SICOM_PATHS } from 'src/sicom-paths';
@Injectable({ providedIn: 'root' })
export class PrestadorAnotacoesService {
    private readonly http = inject(HttpClient);
    private readonly url = SICOM_PATHS.registro.prestador.anotacoes;
    listar(id: number, uf: string, tipo: PrestadorAnotacaoTipo) {
        return this.http.get<{ content: PrestadorAnotacao[] }>(this.url, { params: { id, uf, tipo, page: 0, size: 50 } });
    }

    listarContratoSocial(id: number, uf: string) {
        return this.listar(id, uf, 'CONTRATO_SOCIAL');
    }
    listarDividaAtiva(id: number, uf: string) {
        return this.listar(id, uf, 'DIVIDA_ATIVA');
    }
    listarLancamentos(id: number, uf: string) {
        return this.listar(id, uf, 'LANCAMENTOS');
    }
    listarPortalServicos(id: number, uf: string) {
        return this.listar(id, uf, 'PORTAL_SERVICOS');
    }
    listarGerais(id: number, uf: string) {
        return this.listar(id, uf, 'GERAIS');
    }

    criar(request: PrestadorAnotacaoSalvarRequest, context?: HttpContext) {
        return this.http.post<void>(this.url, request, { context });
    }
}
